export const POIMock = [
  {
    "id": 80,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "Morin",
    "categories": [
      {
        "id": "deserunt",
        "name": "consequat"
      }
    ],
    "name": "mollit",
    "description": "Nostrud cillum cupidatat qui in duis quis ullamco minim sit anim proident magna tempor.",
    "x": 52.124793087,
    "y": 21.175645859
  },
  {
    "id": 81,
    "isAccepted": false,
    "isGlobal": false,
    "creatorName": "Chasity",
    "categories": [
      {
        "id": "aliqua",
        "name": "proident"
      }
    ],
    "name": "ipsum",
    "description": "Ea fugiat fugiat sunt nisi consectetur nostrud ex adipisicing.",
    "x": 52.207735728,
    "y": 21.056406723
  },
  {
    "id": 82,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Melissa",
    "categories": [
      {
        "id": "id",
        "name": "sunt"
      }
    ],
    "name": "ullamco",
    "description": "Adipisicing duis tempor mollit labore commodo aliquip aliqua duis elit consequat est.",
    "x": 52.142282482,
    "y": 20.926399181
  },
  {
    "id": 83,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Jasmine",
    "categories": [
      {
        "id": "cillum",
        "name": "do"
      }
    ],
    "name": "pariatur",
    "description": "Proident mollit laboris ut sunt ipsum culpa ea.",
    "x": 52.202871517,
    "y": 21.184342117
  },
  {
    "id": 84,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "Kaufman",
    "categories": [
      {
        "id": "sit",
        "name": "tempor"
      }
    ],
    "name": "enim",
    "description": "Dolore Lorem minim labore consectetur fugiat do aute adipisicing.",
    "x": 52.243944175,
    "y": 21.109935934
  },
  {
    "id": 85,
    "isAccepted": false,
    "isGlobal": false,
    "creatorName": "Sharon",
    "categories": [
      {
        "id": "veniam",
        "name": "esse"
      }
    ],
    "name": "culpa",
    "description": "Pariatur pariatur dolor dolore nulla do dolore voluptate sunt veniam est eu labore officia reprehenderit.",
    "x": 52.176053204,
    "y": 21.051668152
  },
  {
    "id": 86,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Kim",
    "categories": [
      {
        "id": "eu",
        "name": "excepteur"
      }
    ],
    "name": "exercitation",
    "description": "Officia esse officia reprehenderit sit proident cillum deserunt laboris excepteur ut commodo nisi.",
    "x": 52.262894035,
    "y": 20.932206071
  },
  {
    "id": 87,
    "isAccepted": false,
    "isGlobal": false,
    "creatorName": "Combs",
    "categories": [
      {
        "id": "amet",
        "name": "laboris"
      }
    ],
    "name": "ullamco",
    "description": "Cillum commodo officia veniam in cupidatat consectetur aliqua fugiat consectetur sit ad minim amet aliquip.",
    "x": 52.341191133,
    "y": 21.120520687
  },
  {
    "id": 88,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Davenport",
    "categories": [
      {
        "id": "incididunt",
        "name": "proident"
      }
    ],
    "name": "cupidatat",
    "description": "Adipisicing adipisicing dolore velit et ullamco.",
    "x": 52.284657259,
    "y": 21.058807114
  },
  {
    "id": 89,
    "isAccepted": false,
    "isGlobal": false,
    "creatorName": "Joanna",
    "categories": [
      {
        "id": "deserunt",
        "name": "duis"
      }
    ],
    "name": "irure",
    "description": "Est in anim occaecat dolor esse sunt exercitation pariatur dolor deserunt ad laborum Lorem.",
    "x": 52.338768409,
    "y": 21.005219375
  },
  {
    "id": 90,
    "isAccepted": true,
    "isGlobal": false,
    "creatorName": "Castaneda",
    "categories": [
      {
        "id": "aute",
        "name": "laboris"
      }
    ],
    "name": "Lorem",
    "description": "Ex sunt cupidatat labore cillum laboris amet labore aute quis in ex.",
    "x": 52.349715812,
    "y": 21.066774536
  },
  {
    "id": 91,
    "isAccepted": true,
    "isGlobal": false,
    "creatorName": "Ryan",
    "categories": [
      {
        "id": "est",
        "name": "proident"
      }
    ],
    "name": "excepteur",
    "description": "Incididunt deserunt exercitation aliquip ex exercitation tempor.",
    "x": 52.223375164,
    "y": 21.186119983
  },
  {
    "id": 92,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "Rich",
    "categories": [
      {
        "id": "ullamco",
        "name": "do"
      }
    ],
    "name": "dolore",
    "description": "Qui ad occaecat proident esse nulla qui cupidatat consectetur esse amet qui.",
    "x": 52.146803541,
    "y": 21.115268154
  },
  {
    "id": 93,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Rhonda",
    "categories": [
      {
        "id": "incididunt",
        "name": "sit"
      }
    ],
    "name": "magna",
    "description": "In reprehenderit labore minim deserunt non.",
    "x": 52.125635493,
    "y": 21.108349406
  },
  {
    "id": 94,
    "isAccepted": true,
    "isGlobal": false,
    "creatorName": "Belinda",
    "categories": [
      {
        "id": "cupidatat",
        "name": "sint"
      }
    ],
    "name": "dolore",
    "description": "Elit reprehenderit elit nisi enim commodo labore ea duis amet.",
    "x": 52.311037978,
    "y": 21.115240361
  },
  {
    "id": 95,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "Barber",
    "categories": [
      {
        "id": "reprehenderit",
        "name": "eiusmod"
      }
    ],
    "name": "labore",
    "description": "Cillum dolor id irure sit dolor non voluptate amet minim duis.",
    "x": 52.242505191,
    "y": 20.926709396
  },
  {
    "id": 96,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Leonor",
    "categories": [
      {
        "id": "incididunt",
        "name": "officia"
      }
    ],
    "name": "ipsum",
    "description": "Commodo commodo irure enim dolore minim do.",
    "x": 52.314661539,
    "y": 21.064586573
  },
  {
    "id": 97,
    "isAccepted": false,
    "isGlobal": true,
    "creatorName": "Cobb",
    "categories": [
      {
        "id": "incididunt",
        "name": "anim"
      }
    ],
    "name": "eu",
    "description": "Aute magna Lorem Lorem sit laboris labore laboris voluptate in.",
    "x": 52.301683944,
    "y": 21.176285541
  },
  {
    "id": 98,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "English",
    "categories": [
      {
        "id": "anim",
        "name": "ea"
      }
    ],
    "name": "sint",
    "description": "Laboris non velit do ea qui pariatur officia irure consectetur.",
    "x": 52.201822633,
    "y": 21.105225997
  },
  {
    "id": 99,
    "isAccepted": true,
    "isGlobal": true,
    "creatorName": "Carter",
    "categories": [
      {
        "id": "consequat",
        "name": "consectetur"
      }
    ],
    "name": "officia",
    "description": "Tempor esse velit reprehenderit est amet ut excepteur elit consectetur.",
    "x": 52.200619751,
    "y": 21.067146277
  }
]